/*!
 * Copyright (c) 2017-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

// import React, { useEffect } from 'react';
// import { useOktaAuth } from '@okta/okta-react';
// import { toRelativeUrl } from '@okta/okta-auth-js';
// import { Outlet } from 'react-router-dom';


// export const RequiredAuth = () => {
//   const { oktaAuth, authState } = useOktaAuth();
//   console.log("AUTH STATE IN SECURE ROUTE COMPONENT")
//   console.log(authState)
//   useEffect(() => {
//     if (!authState) {
//       return;
//     }

//     if (!authState?.isAuthenticated) {
//       const originalUri = toRelativeUrl(window.location.href, window.location.origin);
//       oktaAuth.setOriginalUri(originalUri);
//       oktaAuth.signInWithRedirect();
//     }
//   }, [oktaAuth, authState?.isAuthenticated, authState]);

//   if (!authState || !authState?.isAuthenticated) {
//     return (<>Loading...</>);
//   }

//   return (<Outlet />);
// }


import React, { useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { Outlet, useLocation } from 'react-router-dom';

export const RequiredAuth = () => {
  const { instance, accounts } = useMsal();
  const location = useLocation();
  const [initialized, setInitialized] = useState(false);
  const isAuthenticated = accounts.length > 0;

  useEffect(() => {
    const initializeMsal = async () => {
      await instance.initialize(); // Ensure MSAL is initialized
      setInitialized(true);
    };

    initializeMsal();
  }, [instance]);

  useEffect(() => {
    if (initialized && !isAuthenticated) {
      const originalUri = location.pathname + location.search;
      localStorage.setItem('redirectUri', originalUri);
      instance.loginRedirect();
    }
  }, [initialized, isAuthenticated, instance, location]);

  if (!initialized || !isAuthenticated) {
    return (<>Loading...</>);
  }

  return (<Outlet />);
}
